import React, { createContext, useContext, useEffect, useState } from "react";

const KEY = "tc-gst-registered";
const GstContext = createContext(null);

export function GstProvider({ children }) {
  const [gstRegistered, setGstRegistered] = useState(() => {
    const raw = localStorage.getItem(KEY);
    if (raw === null) return true; // sensible NZ default — most active tradies are GST-registered
    return raw === "true";
  });

  useEffect(() => {
    localStorage.setItem(KEY, String(gstRegistered));
  }, [gstRegistered]);

  return (
    <GstContext.Provider value={{ gstRegistered, setGstRegistered, toggleGst: () => setGstRegistered((s) => !s) }}>
      {children}
    </GstContext.Provider>
  );
}

export function useGst() {
  const ctx = useContext(GstContext);
  if (!ctx) throw new Error("useGst must be used inside GstProvider");
  return ctx;
}
